import { newI18n } from 'src/i18n'

export enum ElevationGraphicsModeValue {
  CUSTOM = 'Custom',
  ELEVATION = 'Elevation',
  SLOPE = 'Slope'
}

export namespace ElevationGraphicsModeValue {
  export function getLabel(item: ElevationGraphicsModeValue) {
    switch (item) {
      case ElevationGraphicsModeValue.CUSTOM:
        return newI18n.global.t('simulator.elevationGraphics.custom')
      case ElevationGraphicsModeValue.ELEVATION:
        return newI18n.global.t('simulator.elevationGraphics.elevation')
      case ElevationGraphicsModeValue.SLOPE:
        return newI18n.global.t('simulator.elevationGraphics.slope')
    }
  }

  export function getIcon(item: ElevationGraphicsModeValue) {
    switch (item) {
      case ElevationGraphicsModeValue.CUSTOM:
        return 'mi mi-personalized'
      case ElevationGraphicsModeValue.ELEVATION:
        return 'mi mi-elevation'
      case ElevationGraphicsModeValue.SLOPE:
        return 'mi mi-slope'
    }
  }

  export function getSelectOption(item: ElevationGraphicsModeValue) {
    return {
      option: item,
      label: ElevationGraphicsModeValue.getLabel(item),
      icon: ElevationGraphicsModeValue.getIcon(item)
    }
  }
}
